import FooterPrivacyMenu from './MenuFooterPrivacy'

export default FooterPrivacyMenu
